import { z } from "zod";
import { BaseResponseSchema } from "../../common/response/BaseResponseSchema";
import { PropertyBankSchema } from "./ShowBankResponse";

export const UpdateBankResponseSchema = BaseResponseSchema.extend({
    data: PropertyBankSchema,
});

export type UpdateBankResponse = z.infer<typeof UpdateBankResponseSchema>;